// removed by extract-text-webpack-plugin
module.exports = {"content":"_2lnl4qbe"};


//////////////////
// WEBPACK FOOTER
// ./app/errors/containers/error/error.styles.scss
// module id = 672
// module chunks = 0